import React from 'react';
import { motion } from 'framer-motion';
import { Image as ImageIcon, Map, Repeat } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    title: 'Memorizar',
    description: 'Convierte información en imágenes mentales',
    icon: ImageIcon,
    glow: 'shadow-[0_0_30px_rgba(59,130,246,0.2)]',
    border: 'hover:border-cerebro-blue/50'
  }, {
    title: 'Mapear',
    description: 'Organiza tu mente con mapas visuales',
    icon: Map,
    glow: 'shadow-[0_0_30px_rgba(34,211,238,0.2)]',
    border: 'hover:border-cyan-400/50'
  }, {
    title: 'Mantener',
    description: 'Recuerda a largo plazo con repetición inteligente',
    icon: Repeat,
    glow: 'shadow-[0_0_30px_rgba(249,115,22,0.2)]',
    border: 'hover:border-cerebro-orange/50'
  }];
  return <section className="py-24 relative bg-slate-900/30" data-id="element-137">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-139">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-4" data-id="element-140">
            La solución:{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cerebro-blue to-cyan-400" data-id="element-141">
              Método M3
            </span>
          </h2>
          <div className="w-24 h-1 bg-cerebro-blue mx-auto rounded-full shadow-[0_0_10px_rgba(59,130,246,0.5)]" data-id="element-142"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-143">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-cerebro-blue via-cyan-400 to-cerebro-orange opacity-30 -translate-y-1/2 z-0" data-id="element-144"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className={`glass-card p-8 relative z-10 flex flex-col items-center text-center transition-all duration-300 ${step.border} hover:-translate-y-2`} data-id="element-145">
              <div className={`w-20 h-20 rounded-2xl bg-slate-800 flex items-center justify-center mb-6 ${step.glow}`} data-id="element-146">
                <step.icon className="w-10 h-10 text-white" data-id="element-147" />
              </div>
              <h3 className="text-2xl font-display font-bold text-white mb-4" data-id="element-148">
                {step.title}
              </h3>
              <p className="text-slate-300 text-lg leading-relaxed" data-id="element-149">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}